module.exports = __webpack_public_path__ + "img/cita-especialista.3036a420.png";